<template>
    <v-container fluid text-center>
        <v-row>
            <v-col align="center" justify="center" class="azul--text">
                <v-card
                    max-width="450px"
                    class="azul--text text-center"
                    elevation="0"
                >
                    <v-card-title class="justify-center">
                        <strong>
                            Contacto
                        </strong>
                    </v-card-title>
                    <v-card-text>
                        <v-list disabled>
                            <v-list-item-group
                                v-for="(item, i) in contactInfo"
                                :key="i"
                            >
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon
                                            color="azul"
                                            v-text="item.icon"
                                        />
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            class="azul--text"
                                            v-text="item.text"
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col align="start" justify="center">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.9494234551953!2d-60.7591726846395!3d-32.92593447817055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b6529a0fe4562b%3A0xfd06efdca2aa5c5c!2sDroguer%C3%ADa%20Ciafarma!5e0!3m2!1sen!2sar!4v1591103445256!5m2!1sen!2sar"
                    width="450"
                    height="300"
                    frameborder="0"
                    style="border: 0;"
                    allowfullscreen=""
                    aria-hidden="false"
                    tabindex="0"
                />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { contactData } from '../utils';

export default {
    data: () => ({
        contactInfo: [
            {
                icon: 'mdi-map-marker',
                text: contactData.direccion
            },
            {
                icon: 'mdi-whatsapp',
                text: contactData.cellphone
            },
            {
                icon: 'mdi-email-outline',
                text: contactData.email
            }
        ]
    })
};
</script>
